// removed by extract-text-webpack-plugin
module.exports = {"box":"_3h_2d-bRdIBs7N6YiUjRgt"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Box/style.css
// module id = 430
// module chunks = 38